import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';

@Component({
  selector: 'app-trip-counts',
  templateUrl: './trip-counts.component.html',
  styleUrls: ['./trip-counts.component.css']
})
export class TripCountsComponent implements OnInit {

  

  public matFormSize = '12px';
  public searchForm: FormGroup;

  public noDataFoundEnable: boolean = false;
  public excelData = {};

  public maxDate = new Date();
  public maxEndDate = new Date();
  date = new Date();

  public errorObject: any = {
    startDate: '',
    endDate: '',
  }
  public formSubmitted: boolean = false;
  public safeDropEmpExlData = [];

  public showTable: boolean = true;
  public cols: any = [
    { key: '#', display: '#' },
    {
      key: 'vehRegNo', display: 'Vehicle reg no',
      config: {
        isVehicle: true,
      },
      headerConfig:{ isDefault: true}
    },
    { key: 'distance', display: 'Distance' },
    { key: 'tripCount', display: 'Trip count' ,headerConfig:{ isDefault: true}},
  ];

  public tableData: any = [
    {
      "vehRegNo": "TN51AB4545",
      "distance": 237,
      "tripCount": 4,
    }
  ]

  public showDownloadBtn: boolean = false;
  public empDetails: any = {};
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private api: ApiService,
    private com: CommonServices,
    private fb: FormBuilder,
    public excel: ExcelExportService,
  ) { }

  ngOnInit(): void {
    this.searchFormLoad();
  }

  searchFormLoad() {
    this.searchForm = this.fb.group({
      search: new FormControl(''),
      startDate: new FormControl(new Date(), [Validators.required]),
      endDate: new FormControl(new Date(), [Validators.required]),
      transitMode: new FormControl(''),
    });
  }


  validation(data) {
    if (this.errorObject['invalidDate']) delete this.errorObject['invalidDate'];
    let objectKeys = Object.keys(this.errorObject);
    let isValid = true;
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (data[key] == '' || data[key] == undefined || data[key] == null || Number.isNaN(data[key]) || data.length <= 0) {
        this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      } else if ((key == 'startDate' || key == 'endDate')) {
        if (new Date(data.startDate).getTime() > new Date(data.endDate).getTime()) {
          isValid = false;
          this.errorObject['invalidDate'] = 'Invalid from date';
        }
      }
    }
    return isValid;
  }

  checkValidation() {
    let obj = {
      startDate: new Date(this.searchForm.value.startDate).getTime(),
      endDate: new Date(this.searchForm.value.endDate).getTime(),
    }
    if (this.formSubmitted) this.validation(obj);
  }

  onSubmit() {
    console.log(this.searchForm.value);
    this.formSubmitted = true;
    let checkObj = {
      startDate: new Date(this.searchForm.value.startDate).getTime(),
      endDate: new Date(this.searchForm.value.endDate).getTime(),
      search: this.searchForm.value.search,
    }
    let isValid = this.validation(checkObj);
    if (isValid) {
      let obj = {
        startDate: new Date(new Date(this.searchForm.value.startDate).setHours(0)).getTime(),
        endDate: new Date(new Date(this.searchForm.value.endDate).setHours(23, 59, 59)).getTime(),
      }
      if (this.searchForm.value.search != '') obj['search'] = this.searchForm.value.search;
      if (this.searchForm.value.transitMode != '') obj['transitMode'] = this.searchForm.value.transitMode;
      console.log('final obj', obj);
    }
  }

  navToTripCount() {
    this.router.navigateByUrl('/organization/transport-manager/reports/trip-count')
  }

  async exportToExcel() {
    let data = [];

    const startDate = new Date(this.searchForm.value.startDate + '');
    const endDate = new Date(new Date(this.searchForm.value.endDate + '').setHours(23, 59, 59));

    for (let i = 0; i < this.safeDropEmpExlData.length; i++) {
      let item = this.safeDropEmpExlData[i];
      try {
        let res = [
          i + 1,
          item.empRefID && this.empDetails[item.empRefID] && this.empDetails[item.empRefID]['name'] ? this.empDetails[item.employeeID]['name'] : '---',
          item.vehRegNo ? item.vehRegNo : '---',
          item.tripDate ? formatDate(item.tripDate, 'dd/MMM/yyyy', 'en-In') : '--/--/----',

        ];
        data.push(res);
      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {

      const excelInfo = {
        title: {
          title: `Trip Report_`,
          subTitleRow: 'Date : ' + this.com.timestampToDate(new Date(startDate).getTime(), 'DMY H:M:S') + ' to ' + this.com.timestampToDate(new Date(endDate).getTime(), 'DMY H:M:S'),
          font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true },
          mergeCells: 'A1:F2',
        },
        header: {
          headers: ['No.', 'Vehicle Reg No', 'Date', 'Trip Count', 'Distance',],
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFF00' },
            bgColor: { argb: 'FF0000FF' }
          },
          border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        },
        data: {
          data: data,
          columWith: [{ colNo: 2, width: 25 }, { colNo: 3, width: 20 }, { colNo: 4, width: 15 }, { colNo: 5, width: 15 }, { colNo: 6, width: 25 }]
        }
      };

      if (this.excelData['Trip_Report'] == undefined) { this.excelData['Trip_Report'] = {}; }

      this.excelData['Trip_Report'] = excelInfo;

      this.showDownloadBtn = true;
    }

  }

  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'Trip_Report_' + new Date().getTime() + '.xlsx');
  }

}
